import Vue from 'vue';
import ProductDetail from "../vue/ProductDetail.vue"

function initProductdetail() {
    const productdetail = document.getElementById('productDetail');
    if (productdetail) {
    new Vue({
        name: 'ProductDetailElement',
        el: '#productDetail',
        data: () => ({
        }),
        components: {
           ProductDetail
        },
        computed: {
        },
        methods: {
        },
        mounted()
        {
        },
    });
    }
}

document.addEventListener("DOMContentLoaded", initProductdetail);
window.addEventListener("Pageeditor:insert", initProductdetail);
window.addEventListener("Pageeditor:change", initProductdetail);
